import axios from 'axios';

const defaultState = {
  towns: [],
  counties: [],
  allLocationsInfoLoaded: false,
};

const getters = {
  getTownsInCounty: (state) => (countyId) => {
    return state.towns.filter((town) => {
      return town.Level2 === countyId;
    });
  },

  /**
   * @param state
   * @param getters
   *
   * @returns {{searchUrl: String, label: String, towns: {searchUrl: String, label: String}[]}[]}
   */
  getCountiesWithTowns: (state, getters) => {
    const result = [];

    // loop through all counties
    state.counties.forEach((county) => {
      const countyTowns = getters.getTownsInCounty(county.AggregateLocationID);

      // only include counties with towns
      if (!countyTowns.length) {
        return;
      }

      // transform county and town objects to their URLCode and Label
      const countyResultObject = {
        searchUrl: `/agencysearch/bycounty/${county.UrlLocator}.htm`,
        label: county.Label,
        towns: [],
      };

      countyTowns.forEach((town) => {
        countyResultObject.towns.push({
          searchUrl: `/agencysearch/bytown/${town.UrlLocator}.htm`,
          label: town.Label,
        });
      });

      result.push(countyResultObject);
    });
    return result;
  },
};

const mutations = {
  setTowns(state, towns) {
    state.towns = towns;
  },
  setCounties(state, counties) {
    state.counties = counties;
  },
  setAllLocationsInfoLoaded(state, loaded = true) {
    state.allLocationsInfoLoaded = loaded;
  },
};

const actions = {
  async getAllLocationsInfo({ state, commit }) {
    if (state.allLocationsInfoLoaded) {
      return;
    }
    const response = await axios.get('/api/allLocations');
    commit('setTowns', response.data.towns);
    commit('setCounties', response.data.counties);
    commit('setAllLocationsInfoLoaded');
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: defaultState,
};
